<template>
  <div class="ed_container" :style="`width: ${width}px`">
    <editor
      :id="id"
      :width="`${width}px`"
      :height="`${height}px`"
      ref="editor"
      :afterFocus="showTag"
      :content.sync="richTextContent"
      @on-content-change="onContentChange"
      :resizeType="0"
      :minChangeSize="1"
      :autoHeightMode="true"
      :minHeight="30"
      :items="item"
      :cssData="cssData"
    ></editor>
    <div class="tips" v-if="maxTextLen > 0">{{$t('components_my_rich_text_kind_editor _ 副本_2426', [ textLen , maxTextLen ])}}</div>
    <div class="tips" v-else style="color: red;">{{$t('components_my_rich_text_kind_editor _ 副本_2427', [ textLen , -maxTextLen ])}}</div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'kind_editor',
  props: {
    content: {
      type: String,
      defalut: ''
    },
    maxLen: {
      type: Number,
      default: 10000
    },
    width: {
      type: String,
      default: '650'
    },
    height: {
      type: String,
      default: '260'
    },
    id:{
        type:String,
        defalut:'editor'
    },
    cssData: {
      type: String,
      default: 'body{line-height:1.5;}'
        + 'p{margin:0px 0px 16px 0px;}'
        + 'h1,h2,h3,h4,h5,h6{margin:0px;}'
        + 'p{font-size:16px;color:#333;font-family:Arial;}'
        + 'h1{font-size:26px;color:#333;font-family:Arial;font-weight:700;}'
        + 'h2{font-size:24px;color:#333;font-family:Arial;font-weight:700;}'
        + 'h3{font-size:18px;color:#333;font-family:Arial;font-weight:700;}'
        + 'h4{font-size:16px;color:#333;font-family:Arial;font-weight:700;}'
        + 'h5{font-size:15px;color:#333;font-family:Arial;font-weight:700;}'
        + 'h6{font-size:14px;color:#333;font-family:Arial;font-weight:700;}'
    }
  },
  computed: {
    maxTextLen () {
      return this.maxLen - this.textLen
    }
  },
  watch: {
    content (val) {
      this.richTextContent = val
    },
    richTextContent (val) {
      this.textLen = this.$refs.editor.editor.count('text')
      this.$emit('on-content-change', this.richTextContent, this.textLen)
      this.$emit('update:content', val)
    },
    module_Data(){
      return this.$store.state.app.module_Data;
    },
  },
  data () {
    return {
      richTextContent: this.content,
      item: ['source', 'selectall', 'plainpaste', 'undo', 'redo', 'fontname', 'fontsize', 'forecolor', 'hilitecolor', 'bold', 'underline', 'italic', 'subscript', 'superscript', 'align', 'lineheight', 'indent', 'outdent', 'insertorderedlist', 'insertunorderedlist', 'image', 'flash', 'link', 'unlink', 'media', 'table', 'hr', 'pagebreak', 'clearhtml', 'fullscreen'],
      textLen: 0,
      timer:null
    }
  },
  mounted () {
    const _this = this
    KindEditor('.ke-icon-image').click(function () {
      _this.$store.commit('image_upload/set_fileType', 1)
      _this.$store.commit('image_upload/set_fileLimit', 1)
      _this.$store.commit("image_upload/set_showTag", true)
      _this.$store.state.image_upload.imgFile = (e) => {
        window.rich_text_add_img(e[0].filePath, e[0].fileName);
      }
    })
    this.$nextTick(() => {
      this.textLen = this.$refs.editor.editor.count('text')
      this.$emit('on-content-change', this.richTextContent, this.textLen)
    })
  },
  methods: {
    addActiveClass(){
      console.log(2222)
      let id
      console.log(this.$store.state.app.module_Data)
      if(this.$store.state.app.module_Data&&this.$store.state.app.module_Data.widgets_id){
        id = this.$store.state.app.module_Data.widgets_id
        let _that = this
        this.timer = setTimeout(()=>{
          if($(`#u${id} .ke-selected[data-name='bold']`).length == 1){
              // $('.icon.bold').addClass('active')
              _that.$store.commit('font_style/SET_bold', true);
          }else{
              _that.$store.commit('font_style/SET_bold', false);
          }
          if($(`#u${id} .ke-selected[data-name='underline']`).length == 1){
              _that.$store.commit('font_style/SET_underline', true);
          }else{
              _that.$store.commit('font_style/SET_underline', false);
          }
          if($(`#u${id} .ke-selected[data-name='italic']`).length == 1){
              _that.$store.commit('font_style/SET_italics', true);
          }else{
              _that.$store.commit('font_style/SET_italics', false);
          }
          _that.timer = null
        },500)
      }
    },
    showTag(){
      let id
      console.log(this.$store.state.app.module_Data)
      if(this.$store.state.app.module_Data&&this.$store.state.app.module_Data.widgets_id){
        id = this.$store.state.app.module_Data.widgets_id
        let _that = this
            // debugger
        // _that.addActiveClass()
        console.log(3333333333333)
        if(id){
      console.log(3333333333333)
          // $(`#u${id} .ke-edit-iframe`)[0].contentDocument.onclick = function(){
            // _that.addActiveClass()
          // }
        }
      }
    },
    onContentChange (content) {
      // console.log(content)
      // this.richTextContent = content
      // this.textLen = this.$refs.editor.editor.count('text')
      // this.$emit('on-content-change', this.richTextContent, this.textLen)
    }
  },
}
</script>

<style>
.ed_container {
  position: relative;
  width: 650px;
  margin: 0 auto;
}
.ed_container .tips{
  text-align: right;
  border: 1px solid #CCCCCC;
  border-top: none;
  color: #aaa;
  font-size: 12px;
}
.ke-statusbar {
  display: none;
}
.ke-toolbar {
  background-color: #fff;
}
.ke-statusbar {
  background-color: #fff;
}
.ke-edit-iframe {
  position: static;
}
.ke-toolbar-icon {
  width: 16px;
  height: 16px;
}
/* 全选 */
.ke-icon-selectall {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -258px;
}
/* 无格式文本 */
.ke-icon-plainpaste {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -308px;
}
/* 后退 */
.ke-icon-undo {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -8px;
}
/* 前进 */
.ke-icon-redo {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -58px;
}
/* 粗体 */
.ke-icon-bold {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -458px;
}
/* 下划线 */
.ke-icon-underline {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -558px;
}
/* 斜体 */
.ke-icon-italic {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -508px;
}
/* 删除线 */
.ke-icon-strikethrough {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -608px;
}
/* 下标 */
.ke-icon-subscript {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -658px;
}
/* 上标 */
.ke-icon-superscript {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -708px;
}
/* 行距 */
.ke-icon-lineheight {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -308px -408px;
}
/* 对齐 */
.ke-icon-align {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -308px -108px;
}
.ke-icon-justifyleft {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -248px -106px;
}
.ke-icon-justifycenter {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -248px -156px;
}
.ke-icon-justifyright {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -248px -206px;
}
.ke-icon-justifyfull {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -248px -256px;
}
/* 视频 */
.ke-icon-media {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -128px -208px;
}
/* 表格 */
.ke-icon-table {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -128px -58px;
}
/* 全屏 */
.ke-icon-fullscreen {
  background: url(~@/assets/image/rich_text_qt.png) no-repeat -8px -158px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_text_rich/kind_editor.vue